/* eslint-disable semi */

import qs from 'query-string';

const debug = process.env.NODE_ENV === 'development';

/**
 * クエリに連動可能な値か判定する
 * 連動可能な型は、null・文字列・文字列の配列のみ。
 * @param {*} value
 */
function isHandleableQueryValue (value) {
  if (value === null) {
    return true;
  } else if (typeof value === 'string') {
    return true;
  } else if (Array.isArray(value)) {
    return value.every(val => typeof val === 'string');
  } else {
    return false;
  }
}

const RouterAlterer = {
  /**
   * クエリ文字列を解析してパラメータを取得する
   * @param {*} query
   */
  parseQuery (query) {
    const parsed = qs.parse(query, { arrayFormat: 'bracket' });
    const corrected = {};

    for (let key in parsed) {
      let val = parsed[key];

      if (isHandleableQueryValue(val)) {
        corrected[key] = val;
      } else {
        if (debug) {
          console.warn(`${key} -> ${val} can't parse.`);
        }
      }
    }

    return corrected;
  },

  /**
   * パラメータをクエリ文字列に変換する
   * @param {*} params
   */
  stringifyQuery (params) {
    const corrected = {};

    for (let key in params) {
      let val = params[key];

      // 1) convert empty array to null.
      //    because key that has empty array will not be stringifyed.
      val = Array.isArray(val) && val.length === 0 ? null : val;

      // check contains object.
      if (isHandleableQueryValue(val)) {
        corrected[key] = val;
      } else {
        if (debug) {
          console.error(`${key}: ${val} can't stringify.`);
        }
      }
    }

    if (Object.keys(corrected).length === 0) {
      return '';
    } else {
      return '?' + qs.stringify(corrected, { arrayFormat: 'bracket' });
    }
  }
}
export default RouterAlterer;



// WEBPACK FOOTER //
// ./src/core/libs/RouterAlterer.js